<template>
  <div class="role-page full-height">
    <table-con>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/orders' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>系统管理</el-breadcrumb-item>
          <el-breadcrumb-item>操作记录</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="search">
        <el-row class="search-row">
          <el-col :span="6" class="display-row">
            <div class="query-title" style="text-align:right">订单编号:</div>
            <div class="flex1">
              <el-input
                  placeholder="请输入No"
                  clearable
                  v-model="queryInfo.orderId"
                  size="small"
                  @keyup.enter.native="searchList"
              >
              </el-input>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title">操作开始日:</div>
            <div class="flex1">
              <el-date-picker
                  clearable
                  v-model="queryInfo.createTimeStart"
                  type="date"
                  size="small"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期">
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title">操作结束日:</div>
            <div class="flex1">
              <el-date-picker
                  clearable
                  v-model="queryInfo.createTimeEnd"
                  type="date"
                  size="small"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期">
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title" style="text-align:right">操作人:</div>
            <div class="flex1">
              <el-input
                  placeholder="请输入操作人"
                  clearable
                  v-model="queryInfo.createUserName"
                  size="small"
                  @keyup.enter.native="searchList"
              >
              </el-input>
            </div>
          </el-col>
        </el-row>
        <el-row class="search-row">
          <el-col :span="6" class="display-row">
            <div class="query-title" style="text-align:right">操作后状态:</div>
            <div class="flex1" style="float:right">
              <el-select v-model="queryInfo.targetState" placeholder="请选择" size="small" clearable>
                <el-option
                    v-for="item in orderStatusOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="18" class="display-row">
            <div style="text-align:right;width:100%;padding-right:10px;float:right">
              <el-button class="search-btn btn-gray" @click="queryInfoClear">重置</el-button>
              <el-button class="search-btn btn-blue" @click="searchList">搜索</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <div slot="table" class="full-height display-col">
        <el-table
            :header-cell-style="tableStyle.headerStyle"
            :cell-style="tableStyle.cellStyle"
            :data="recordList"
            border
            height="550"
        >
          <el-table-column type="index" align="center" label="序号" width="40"></el-table-column>
          <el-table-column prop="orderId" align="center" label="订单编号"></el-table-column>
          <el-table-column
              prop="souceState"
              :index="indexMethod"  sortable
              align="center"
              label="原始状态">
          </el-table-column>
          <el-table-column
              prop="targetState"
              :index="indexMethod"  sortable
              align="center"
              label="现存状态">
          </el-table-column>
          <el-table-column
              prop="createUserName"
              align="center"
              label="操作人">
          </el-table-column>
          <el-table-column
              prop="createUserRealName"
              align="center"
              label="姓名">
          </el-table-column>
          <el-table-column
              prop="createTime"
              sortable
              :index="indexMethod"
              align="center"
              width="160"
              label="操作时间">
            <template v-slot="scope">
              {{ scope.row.createTime | dateFormatToSecond }}
            </template>
          </el-table-column>
          <el-table-column
              prop="note"
              label="操作节点">
          </el-table-column>
          <el-table-column
              prop="content"
              label="操作内容">
          </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryInfo.pageNum"
            :page-sizes="[5, 10, 20, 50, 100, 200]"
            :page-size="queryInfo.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
        ></el-pagination>
      </div>
    </table-con>
  </div>
</template>

<script>
import tableCon from '../../views/tableContainer'

export default {
  name: 'orderStateLog',
  // name: 'system/OrderStateLog',
  components: {tableCon},
  data() {
    return {
      queryInfo: {
        orderId: '',
        createTimeStart: '',
        createTimeEnd: '',
        createUserName: '',
        targetState: '',
        pageSize: 10,
        pageNum: 1
      },
      // orderDateRangeValue: [],
      recordList: [],
      total: 0,
      value: ''
    }
  },
  methods: {
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getrecordList();
    },
    handleCurrentChange(newPage) {
      this.queryInfo.pageNum = newPage;
      this.getrecordList();
    },
    orderDateRange() {

    },
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    },
    searchList() {    //查询
      this.queryInfo.pageNum = 1;
      this.getrecordList();
    },
    async getrecordList() {
      console.log(this.queryInfo);
      const {data: res} = await this.$http.get('cms/orderStateLog/list', {params: this.queryInfo});
      console.log(res);
      this.recordList = res.data.list;
      this.total = res.data.total;
    },
    queryInfoClear() {    //清空
      this.queryInfo = {
        orderId: '',
        createTimeStart: '',
        createTimeEnd: '',
        createUserName: '',
        targetState: '',
        pageSize: 10,
        pageNum: 1
      }
      // this.orderDateRangeValue = [];
    },
  },
  watch: {
    //监听时间选择器绑定值变化
    // orderDateRangeValue() {
    //   //解决时间选择器清空后 绑定值为null问题
    //   if (!this.orderDateRangeValue) {
    //     this.orderDateRangeValue = [];
    //     this.queryInfo.createTimeStart = '';
    //     this.queryInfo.createTimeEnd = '';
    //   } else {
    //     if (this.orderDateRangeValue.length > 0) {
    //       this.queryInfo.createTimeStart = this.orderDateRangeValue[0];
    //       this.queryInfo.createTimeEnd = this.orderDateRangeValue[1];
    //     }
    //   }
    //
    // }
  },
  created() {
    this.getrecordList();
    this.orderStatusOptions = [
      {
        value: '等待到库',
        label: '等待到库'
      },
      {
        value: '到库',
        label: '到库'
      },
      {
        value: '检品中',
        label: '检品中'
      },
      {
        value: '检品完',
        label: '检品完'
      },
      {
        value: '仓库保管中',
        label: '仓库保管中'
      },
      {
        value: '申请发货',
        label: '申请发货'
      },
      {
        value: '不良待处理',
        label: '不良待处理'
      },
      {
        value: '不良驳回',
        label: '不良驳回'
      },
      {
        value: '换货待发回',
        label: '换货待发回'
      },
      {
        value: '换货等待到货',
        label: '换货等待到货'
      },
      {
        value: '待部分退货',
        label: '待部分退货'
      },
      {
        value: '补发等待到货',
        label: '补发等待到货'
      },
      {
        value: '待支付',
        label: '待支付'
      },
      {
        value: '待发送',
        label: '待发送'
      },
      {
        value: '已发送',
        label: '已发送'
      },
      {
        value: '已取消',
        label: '已取消'
      },
      {
        value: '退货申请中',
        label: '退货申请中'
      },
      {
        value: '退货待支付',
        label: '退货待支付'
      },
      {
        value: '待退货',
        label: '待退货'
      },
      {
        value: '已退货',
        label: '已退货'
      },
      {
        value: '销毁申请中',
        label: '销毁申请中'
      },
      {
        value: '销毁待支付',
        label: '销毁待支付'
      },
      {
        value: '待部分销毁',
        label: '待部分销毁'
      },
      {
        value: '已销毁',
        label: '已销毁'
      },
      {
        value: '装箱中',
        label: '装箱中'
      },
    ];
  }
};
</script>

<style lang="less" scoped>
.role-page > .search-container {
  height: 60px !important;
}

.el-table .el-button--small {
  padding: 4px 10px;
}
</style>
